import React from 'react'
import './RecommendedVideos.css';
import VideoCard from './VideoCard';

function RecommendedVideos() {
    return (
        <div className="recommendedVideos">
            <h2>Recomended Videos</h2>
            <div className="recommendedVideos__videos">
                <VideoCard
                    title="Become a Web Developer in 10 minutes"
                    views="2.3M Views"
                    timestamp="3 days ado"
                    image="https://i.ytimg.com/vi/yiqFxDx2WW4/hqdefault.jpg?sqp=-oaymwEcCOADEI4CSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBXSMkowYo5tUZeEIoFID-MxYTpAA"
                    channel="UK channel"
                    channelImage="https://i.ytimg.com/vi/qbn7MQLOfYE/maxresdefault.jpg"
                />
                <VideoCard
                    title="The Walk On -  At The Masters Saturday 30th January 2021 Afternoon Session"
                    views="125 Views"
                    timestamp="4 days ado"
                    image="https://i.ytimg.com/vi/HFAirMP5QZk/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBxYwXmfbkDvcLfYTcQkgNb7rF0eA"
                    channel="UK channel"
                    channelImage="https://yt3.ggpht.com/ytc/AAUvwngwDpks7CTW5cVF6Yz9QMQ4X1DC6N32Z7QGbwap=s68-c-k-c0x00ffffff-no-rj"
                />
                <VideoCard
                    title="AFC Cup 2021 - Group Stage Draw Recap Show"
                    views="20k Views"
                    timestamp="2 days ado"
                    image="https://i.ytimg.com/vi/1CQ5-qMU1f4/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBaib9VRvin0lKqlKQCuTYw8vSxfQ"
                    channel="UK channel"
                    channelImage="https://yt3.ggpht.com/ytc/AAUvwniPcHsFMmseEQHUu7ycDBRfBKw83ROv51WJZebuQw=s68-c-k-c0x00ffffff-no-rj"
                />
                <VideoCard
                    title="HSBC BWF World Tour Finals"
                    views="5M Views"
                    timestamp="1 days ado"
                    image="https://i.ytimg.com/vi/b4OXLU9EJL8/hq720_live.jpg?sqp=CMyp1YAG-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDn8pVLLT-rvgHGxsZPA_iD1vC14A"
                    channel="BWF TV"
                    channelImage="https://yt3.ggpht.com/ytc/AAUvwnjcht_TC4w5-ISF4sFIhnbRjvUWGSycMIXCU4quIA=s68-c-k-c0x00ffffff-no-rj"
                />
                <VideoCard
                    title="Become a Web Developer in 10 minutes"
                    views="1M Views"
                    timestamp="4 days ado"
                    image="https://i.ytimg.com/vi/N_EtzTKE3Xk/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAtX68ZS8yOBHaJk_Om586WV8qpLA"
                    channel="Skating ISU"
                    channelImage="https://yt3.ggpht.com/ytc/AAUvwnhOms0a1D5uTDKt_0iKJbjh8uYNy1FZxuiQq3Lb8A=s68-c-k-c0x00ffffff-no-rj"
                />
                <VideoCard
                    title="Resumen de Real Valladolid vs SD Huesca (1-3)"
                    views="2.3M Views"
                    timestamp="3 days ado"
                    image="https://i.ytimg.com/vi/tzNjSYOgKQA/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDWwZXREKb-SAlg6Afn63LSnol8tA"
                    channel="UK channel"
                    channelImage="https://yt3.ggpht.com/ytc/AAUvwnj4M4We5Cn660BxAMtOCe0-2zj-wE_2d2Ivd1-fSA=s68-c-k-c0x00ffffff-no-rj"
                />
                <VideoCard
                    title="Become a Web Developer in 10 minutes"
                    views="2.3M Views"
                    timestamp="3 days ado"
                    image="https://i.ytimg.com/vi/yiqFxDx2WW4/hqdefault.jpg?sqp=-oaymwEcCOADEI4CSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBXSMkowYo5tUZeEIoFID-MxYTpAA"
                    channel="UK channel"
                    channelImage="https://i.ytimg.com/vi/qbn7MQLOfYE/maxresdefault.jpg"
                />
               
               
            </div>
        </div>
    )
}

export default RecommendedVideos
